import React from 'react';
import SectionCard from '../controls/SectionCard';
import Toggle from '../controls/Toggle';
import Button from '../controls/Button';
import styles from './CommonActions.module.css';

const CommonActions = ({ model, onDuplicate, onDelete, onSaveAsUpload, canSaveAsUpload }) => {
  const { lockedState, applyToSelection } = model;
  const isMixed = lockedState.mixed;
  const isLocked = lockedState.allLocked;

  const handleToggleLock = () => {
    const nextValue = isMixed ? true : !isLocked;
    applyToSelection({ locked: nextValue }, 'immediate', 'toggle-lock');
  };

  return (
    <SectionCard title="Actions">
      <div className={styles.actions}>
        <Toggle
          checked={isLocked}
          indeterminate={isMixed}
          onChange={handleToggleLock}
          label="Lock"
        />
        <Button onClick={onDuplicate}>Duplicate</Button>
        <Button variant="danger" onClick={onDelete}>Delete</Button>
        {onSaveAsUpload && (
          <Button onClick={onSaveAsUpload} disabled={!canSaveAsUpload}>
            Save to uploads
          </Button>
        )}
      </div>
    </SectionCard>
  );
};

export default CommonActions;
